import { render, staticRenderFns } from "./PaginaNaoEncontrada.vue?vue&type=template&id=400b96f2"
import script from "./PaginaNaoEncontrada.vue?vue&type=script&lang=js"
export * from "./PaginaNaoEncontrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports